import {Injectable} from '@nestjs/common';
import { PoItems } from '../po-creation-items.entity';
import { PoCreation } from '../po-creation.entity';
import { PurchaseOrderItemsDTO } from './po-creation-items.dto';
import { PoItemsDetails } from './po-item-details.-create.dto';
//import {PoItemsInfo} from './sale-order-items-info.model';

@Injectable()
export class PoItemsAdapter {
    /**
     * 
     * @param variantDto 
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity( poItemsDto: PoItemsDetails, poId?:number): PoItems {
        const poItem = new PoItems();
        
        // poItem.purchaseOrderId=poItemsDto.purchaseOrderId;
        poItem.itemCategory=poItemsDto.itemCategory;
        poItem.itemName=poItemsDto.item;
        poItem.size=poItemsDto.size;
        poItem.itemQuantity=poItemsDto.quantity;
        poItem.itemCost=poItemsDto.unitPrice;
        poItem.discountPer=poItemsDto.discountPercentage;
        poItem.discount=poItemsDto.discountAmount;
        poItem.taxPer=poItemsDto.tax;
        poItem.tax=poItemsDto.taxAmount;
        poItem.transportation=poItemsDto.transportation;
        poItem.subAmount=poItemsDto.Amount;
        poItem.purchaseOrderId =poId;
        poItem.bomItemId =poItemsDto.bomItemId;
        poItem.saleOrderId =poItemsDto.saleOrderId;
        poItem.isActive=true;
        if (poItemsDto.purchaseOrderItemId){
            poItem.purchaseOrderItemId=poItemsDto.purchaseOrderItemId;
            poItem.updatedUser = poItemsDto.updatedUser;
        }else {
            poItem.createdUser=poItemsDto.createdUser;
        }
        return poItem;
    }
    
    public convertEntityToDto( poItem: PoItems): PoItemsDetails{
        const poItemsDto = new PoItemsDetails();
        poItemsDto.purchaseOrderItemId=poItem.purchaseOrderItemId;
        // poItemsDto.purchaseOrderId=poItem.purchaseOrderId;
        poItemsDto.itemCategory=poItem.itemCategory;
        poItemsDto.item=poItem.itemName;
        poItemsDto.size=poItem.size;
        poItemsDto.quantity=poItem.itemQuantity;
        poItemsDto.unitPrice=poItem.itemCost;
        poItemsDto.discountPercentage=poItem.discountPer;
        poItemsDto.discountAmount=poItem.discount;
        poItemsDto.tax=poItem.tax;
        poItemsDto.transportation=poItem.transportation;
        poItemsDto.Amount=poItem.subAmount;
        // poItemsDto.otherTerms=poItem.otherTerms;
        // poItemsDto.remarks=poItem.remarks;
        // poItemsDto.isActive=poItem.isActive;
        // poItemsDto.createdAt=poItem.createdAt;
        poItemsDto.createdUser=poItem.createdUser;
        // poItemsDto.updatedAt=poItem.updatedAt;
        poItemsDto.updatedUser=poItem.updatedUser;
        // poItemsDto.versionFlag=poItem.versionFlag;
        // poItemsDto.receivedQuantity=poItem.receivedQuantity;
        return poItemsDto;
    }
}